import {
  DirectionsRun,
  EventNote,
  Explore,
  Gavel,
  Home,
  ListAlt,
  Login,
  Logout,
} from '@mui/icons-material';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@/contexts/AuthContext';
import { useEvent } from '@/contexts/EventsContext';

export default function BottomNav() {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(false);
  const lastScrollY = useRef(0);
  const { t } = useTranslation();
  const router = useRouter();
  const { active: activeEvent, open: openEvents } = useEvent();
  const openEvent = openEvents[0];

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // Hide when scrolling down, show when scrolling up
      setHidden(currentScrollY > lastScrollY.current);
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigationActionsProps = [
    { component: 'a', href: '/', label: t('nav.home'), icon: <Home /> },
    ...(openEvent
      ? [
          {
            component: 'a',
            href: '/events/submit',
            label: t('nav.submit'),
            icon: <DirectionsRun />,
          },
          {
            component: 'a',
            href: '/events/submitted',
            label: t('nav.submitted'),
            icon: <ListAlt />,
          },
        ]
      : [
          activeEvent?.submissionsStartAt && {
            component: 'a',
            href: '/schedule',
            label: t('nav.schedule'),
            icon: <EventNote />,
          },
        ]),
    {
      component: 'a',
      href: '/scavenger',
      label: 'Scavenger Hunt',
      icon: <Explore />,
    },
    ...(user?.isStaff
      ? [
          {
            component: 'a',
            href: '/scavenger/judge',
            label: 'Judge',
            icon: <Gavel />,
          },
        ]
      : []),
    user
      ? { label: t('nav.logout'), icon: <Logout />, href: '/accounts/logout' }
      : { label: t('nav.login'), icon: <Login />, href: '/accounts/login' },
  ].filter(Boolean);

  const value = navigationActionsProps.findIndex(actionProps => actionProps.href === router.route);

  return (
    <BottomNavigation
      showLabels
      value={value}
      sx={[
        {
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 999,
          transition: 'bottom 0.3s ease-in-out', // Smooth transition effect
        },
        // Moves navbar off-screen when hidden
        hidden && { bottom: '-80px' },
      ]}
    >
      {navigationActionsProps.map((actionProps, index) => (
        <BottomNavigationAction
          key={`bottom-navigation-action-${actionProps.href}`}
          sx={{ textAlign: 'center' }}
          disabled={value === index}
          {...actionProps}
        />
      ))}
    </BottomNavigation>
  );
}
